import { ActivityListProps } from "../interfaces/ActivityInterface";
import { AxiosInstance } from "axios";

class ActivityUseCase {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  getActivities(): ActivityListProps {
    return {
      activities: [
        {
          id: "1",
          category: "Restaurant Promotions",
          name: "Momo paradise",
          announce: "Come 4 Pay 3",
          imageUrl: "https://svgshare.com/i/QTc.svg",
          description:
            " Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
        },
        {
          id: "2",
          category: "Events",
          name: "Flutter Class",
          location: "Agoda 44th fl., Central World",
          announce: "MON, 7 SEP 2020",
          imageUrl: "https://svgshare.com/i/QTc.svg",
          description:
            " Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
        },
        {
          id: "3",
          category: "Lifestyle Applications",
          name: "Netflix Family",
          announce: "99 Baths / month",
          imageUrl: "https://svgshare.com/i/QTc.svg",
          description:
            " Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
        },
        {
          id: "4",
          category: "Restaurant Promotions",
          name: "Momo paradise",
          announce: "Come 4 Pay 3",
          imageUrl: "https://svgshare.com/i/QTc.svg",
          description:
            " Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
        },
        {
          id: "5",
          category: "Events",
          name: "Flutter Class",
          location: "Agoda 44th fl., Central World",
          announce: "MON, 7 SEP 2020",
          imageUrl: "https://svgshare.com/i/QTc.svg",
          description:
            " Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
        },
        {
          id: "6",
          category: "Lifestyle Applications",
          name: "Netflix Family",
          announce: "99 Baths / month",
          imageUrl: "https://svgshare.com/i/QTc.svg",
          description:
            " Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
        },
        {
          id: "7",
          category: "Restaurant Promotions",
          name: "Momo paradise",
          announce: "Come 4 Pay 3",
          imageUrl: "https://svgshare.com/i/QTc.svg",
          description:
            " Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
        },
        {
          id: "8",
          category: "Events",
          name: "Flutter Class",
          location: "Agoda 44th fl., Central World",
          announce: "MON, 7 SEP 2020",
          imageUrl: "https://svgshare.com/i/QTc.svg",
          description:
            " Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
        },
        {
          id: "9",
          category: "Lifestyle Applications",
          name: "Netflix Family",
          announce: "99 Baths / month",
          imageUrl: "https://svgshare.com/i/QTc.svg",
          description:
            " Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
        },
        {
          id: "10",
          category: "Restaurant Promotions",
          name: "Momo paradise",
          announce: "Come 4 Pay 3",
          imageUrl: "https://svgshare.com/i/QTc.svg",
          description:
            " Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
        },
        {
          id: "11",
          category: "Events",
          name: "Flutter Class",
          location: "Agoda 44th fl., Central World",
          announce: "MON, 7 SEP 2020",
          imageUrl: "https://svgshare.com/i/QTc.svg",
          description:
            " Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
        },
        {
          id: "12",
          category: "Lifestyle Applications",
          name: "Netflix Family",
          announce: "99 Baths / month",
          imageUrl: "https://svgshare.com/i/QTc.svg",
          description:
            " Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
        },
      ],
    };
  }
}

export default ActivityUseCase;
